var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCustomCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.205 20.298c-.137-.129-.205-.304-.205-.524V4.236c0-.197.071-.368.214-.515a.74.74 0 01.54-.221c.204 0 .378.074.52.22a.702.702 0 01.224.516V18.77c0 .172.086.258.26.258h17.489a.745.745 0 01.753.736.692.692 0 01-.223.523.745.745 0 01-.53.212H2.744a.734.734 0 01-.54-.202zM15.637 9.087A448.728 448.728 0 0122 14.593v2c-2.233-1.97-5.136-4.509-7.33-6.36-1.98-1.67-3.102-2.162-3.877-2.226-.695-.057-1.212.203-2.096.648l-.285.143c-1.388.692-2.763.692-3.393.692H5v-1.5c.61 0 1.682-.006 2.742-.534l.299-.152c.825-.421 1.733-.886 2.875-.792 1.27.105 2.701.87 4.721 2.575z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomCurve);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconCustomCurve.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };